import script from "./OTabelaMembrosProjeto.vue?vue&type=script&lang=ts&setup=true"
export * from "./OTabelaMembrosProjeto.vue?vue&type=script&lang=ts&setup=true"

import "./OTabelaMembrosProjeto.vue?vue&type=style&index=0&id=53a3fc4c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53a3fc4c"]])

export default __exports__